export default String.raw`
{% if usr.Authenticated -%}
<div>
	<div>{{translations.YouAreLoggedInAs}}: {{usr.Email}}</div>
	<div class="primary-action-button">
		{{translations.GoToClientProfile}}
		<a href='{{ page.BaseHref }}{{config.DefinedPages.CustomerProfile.Url}}' rel="noopener noreferrer nofollow" target="_blank">{{translations.CustomerProfile}}</a>
	</div>
</div>
{% elseif config.Registration.Disabled -%}
<div>
	{{translations.BlockedSignUpInfo}}
	<div>
		<a href='{{ page.BaseHref }}{{config.DefinedPages.Contact.Url}}' target="_blank" rel="noopener noreferrer">
			{{translations.Contact}}
		</a>
	</div>
</div>
{% else -%}
	{% if config.CompanyOnly == false -%}
		{% if config.Registration.Retail.AddressVisible -%}
			{% assign retailTemplate = 'static-elements/register-with-address/register-with-address.html' -%}
		{% else -%}
			{% assign retailTemplate = 'static-elements/register-no-address/register-no-address.html' -%}
		{% endif -%}
		{% if config.Registration.Company.AddressVisible -%}
			{% assign companyTemplate = 'static-elements/register-with-address/register-with-address.html' -%}
		{% else -%}
			{% assign companyTemplate = 'static-elements/register-no-address/register-no-address.html' -%}
		{% endif -%}
<div class='registration-js'>
	<div class="reg-container__header remove-tab-title">
		<span>{{ translations.RegisterForm }}</span>
	</div>
	<div class="change-container remove-tab-title">
		<div class="change-container__type">
			<button class="change-type-js container-reload-js replace-template-js change-container__type text {% if include == 'retail' %} active {% endif %}" data-template="{{ retailTemplate }}" data-include="retail">{{ translations.PrivatePerson }}</button>
		</div>
		<div class="change-container__type">
			<button class="change-type-js container-reload-js replace-template-js change-container__type text {% if include == 'company' %} active {% endif %}" data-template="{{ companyTemplate }}" data-include="company">{{ translations.Company }}</button>
		</div>
		<div class="slider"></div>
	</div> 
	{% endif -%}
	<div class="form-js register-form-step-js">
		<input type="hidden" name="__action" value="Customer/Register">
		<input type="hidden" name="company" value="{% if include == 'company' -%} true {% endif -%}">
			<div class="register-step-js">
				<div class='form__input-wrapper'>
					<label for="c-email" data-type="email" class="form__input-info input-info-js"><span class='required'>* </span>{{ translations.Email }}</label>
					<input class="form__input-value input-value-js onlyInputEventValidation" id="c-email" type="email" name="email" value="{{ customer.Email }}" autocomplete="email" maxlength="192" required >
					<div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FieldRequired }}</div>
					<div class="form__invalid-input validation-info-js email-valid-js hidden-js">{{ translations.FillProperEmail }}</div>
				</div>
				<div class='form__input-wrapper'>
					<label for="c-password" class="form__input-info input-info-js"><span class='required'>* </span>{{ translations.Password }}</label>
					<input id="c-password" type="password" class='form__input-value input-value-js onlyInputEventValidation' name="password" value="" title="{{translations.ShowPassword}}" maxlength="50" required autocomplete="new-password" >
					<div tabindex="0" role="button" aria-label="{{ translations.HideShowPassword }}" class="form__icons form__preview form__preview-js">				
						<svg class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#eye-{{settings.iconStyle}}"></use></svg>
					</div>
					<div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FieldRequired }}</div>
					<div class="validation-info__container validation-info-js password-valid-js hidden-js">
						{{ translations.PasswordMustHave }}
						<div class="validation-info__element min-8-char-js">
							<svg class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-circle-{{settings.iconStyle}}"></use></svg>
							<span class="validation-info">{{ translations.Min8Char }}</span>
						</div>
						<div class="validation-info__element big-letter-js">
							<svg class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-circle-{{settings.iconStyle}}"></use></svg>
							<span class="validation-info">{{ translations.BigLetter }}</span>
						</div>
						<div class="validation-info__element small-letter-js">
							<svg class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-circle-{{settings.iconStyle}}"></use></svg>
							<span class="validation-info">{{ translations.SmallLetter }}</span>
						</div>
						<div class="validation-info__element digit-js">
							<svg class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-circle-{{settings.iconStyle}}"></use></svg>
							<span class="validation-info">{{ translations.Digit }}</span>
						</div>
						<div class="validation-info__element special-char-js">
							<svg class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-circle-{{settings.iconStyle}}"></use></svg>
							<span class="validation-info">{{ translations.SpecialChar }}</span>
						</div>
					</div>
				</div>

				{% if include == 'retail' -%}
					{% if config.Registration.Retail.BirthDateVisible == true -%}
						<div class="form__input-wrapper">
							<label for="birthdate" class="form__input-info input-info-js on-label"><span class='required'>{% if config.Registration.Retail.BirthDateRequired == true -%}* {% endif -%}</span>{{ translations.BirthDate }}</label>
							<input id="birthdate" class="form__input-value input-value-js" type="date" name="birthdate" max={{config.Now|Date:'yyyy-MM-dd'}} {% if config.Registration.Retail.BirthDateRequired == true -%} required {% endif -%} {% if customer.BirthDate != null -%} value = {{ customer.BirthDate|Date:'yyyy-MM-dd'}} {% else -%} value="" {% endif -%} >
							<div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FieldRequired }}</div>
						</div>
					{% endif -%}
					{% if config.Registration.Retail.GenderVisible == true -%}
					<div class="form__input-wrapper">
						<label for="gender" class="form__input-info input-info-js"><span class='required'>{% if config.Registration.Retail.GenderRequired == true -%}* {% endif -%}</span>{{ translations.Gender }}</label>
							<select id="gender" type="gender" name="gender" class="form__input-value input-value-js reg-container__select" {% if config.Registration.Retail.GenderRequired == true -%} required{% endif -%}>
								<option value="" disabled hidden {% if customer.Gender == null -%} selected {% endif %} ></option>
								<option aria-label="{{ translations.PreferNotToSay }}" value="2" {% if customer.Gender == 2 -%} selected {% endif -%}>{{ translations.PreferNotToSay }}</option>
								<option aria-label="{{ translations.Male }}" value="1" {% if customer.Gender == 1 -%} selected {% endif -%} > {{ translations.Male }} </option>
								<option aria-label="{{ translations.Female }}" value="0" {% if customer.Gender == 0 -%} selected {% endif -%}> {{ translations.Female }} </option>
							</select>
							<div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FieldRequired }}</div>
					</div>
					{% endif -%}
				{% endif -%}

				{% if include == 'company' -%}
					{% assign chosenType = config.Registration.Company -%}
				{% else -%}
					{% assign chosenType = config.Registration.Retail -%}
				{% endif -%}
				{% assign phoneVisible = chosenType.PhoneVisible -%}
				{% assign phoneRequired = chosenType.PhoneRequired -%}
				{% if phoneVisible -%}
				<div class="form__input-wrapper {% if company -%} company-form-js {% else -%} retail-form-js {% endif -%}">
					<label for="phoneNo" class="form__input-info input-info-js">{% if phoneRequired -%}<span class="required">* </span>{% endif -%}{{ translations.PhoneNumber }}</label>
					<input class="form__input-value input-value-js" id="phoneNo" type="tel" inputmode="numeric" pattern="\d*" name="phoneNo" value="" maxlength="20" {% if phoneRequired -%} required {% endif -%} >
					{% if phoneRequired -%}
					<div class="form__invalid-input validation-required-js hidden-js">{{ translations.FillPhoneNumber }}</div>
					{% endif -%}
				</div>
				{% endif -%}
			</div>
			{% include 'partials/common/consents.html', consentsArea: 'registration', index: '1' -%}
			<div class='reg-container__required-fields'><span class='required'>*</span> {{ translations.RequiredFields }}</div>
			<button aria-label="register" class="primary-action-button register-submit-js" type='submit'>
				<span>{{ translations.MakeAccount }}</span>
			</button>
	</div>
	{% endif -%}
</div>
`